<template>
  <div class="basic_wrap">
    <bsHeader
      :title="$t('user.languagePreference')"
      @backurl="$router.back()"
    />
    <div class="wrap_box">
      <!-- 新增：白色大卡片容器，把所有选项包起来 -->
      <div class="card_container">
        <div
          v-for="(item,index) in languages"
          class="block_div flex_center item"
          @click="changeLang(item.country,$event)"
        >
          <div class="left flex_center">
            <div><img :src="item.logo"></div>
            <div class="info">
              {{ item.country_loc }}
            </div>
          </div>
          <div v-if="lang==item.country" class="check_icon">
            ✓
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Fetch from '../../utils/fetch'
	import bsHeader from '../../components/bsHeader.vue'
	import {
		Toast
	} from 'vant'
	export default {
		name: "Language",
		components: {
			bsHeader
		},
		data() {
			return {
				lang: this.$i18n.locale || "de_de",
				languages: []
			};
		},
		created() {
			if (window.plus) {
				plus.navigator.setStatusBarBackground('#FFFFFF');
				plus.navigator.setStatusBarStyle('dark');
			}
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/index/getLanguages').then(r => {
					this.languages = r.data.list;
				})
			},
			changeLang(lang, event) {
				this.lang = lang;
				this.$i18n.locale = lang;
				localStorage.setItem("lang", lang);
				Fetch("/index/changeLang").then((r) => {
					localStorage.setItem('currency', "");
					localStorage.setItem('precision', r.data.precision);
					localStorage.setItem("language_logo", r.data.language_logo);
					this.$router.go(-1);
				});
			},
		}
	};
</script>

<style lang="less" scoped>
	.basic_wrap{
		/* 截图中的浅蓝色网格纹理背景 */
		background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
		height: 100%;
		min-height: 100vh;
		padding-bottom: 60px;
	}
	
	.wrap_box {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px 16px 0;
	}

	/* 新增：纯白卡片容器 */
	.card_container {
		width: 100%;
		max-width: 450px;
		background: #ffffff;
		border-radius: 18px;
		padding: 0 15px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
		overflow: hidden;
	}

	.item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 70px; /* 增加高度匹配截图 */
		padding: 0 5px;
		font-size: 16px;
		color: #0b1230; /* 改为深色文字 */
		font-weight: 700;
		background: transparent !important; /* 移除原黑色背景 */
		border-bottom: 1px solid #f0f0f0; /* 增加选项间浅色分割线 */
		margin-bottom: 0 !important; /* 移除每个项底部的间距 */
		cursor: pointer;

		&:last-child {
			border-bottom: none; /* 最后一项去掉分割线 */
		}

		.left {
			display: flex;
			align-items: center;
			img {
				width: 32px;
				height: 32px;
				border-radius: 50%; /* 国旗变圆 */
				margin-right: 16px;
				object-fit: cover;
				margin-top: 0; /* 清除原有的 margin-top: 5px */
			}
		}

		/* 选中时的打勾图标 */
		.check_icon {
			font-size: 18px;
			color: #333;
			font-weight: bold;
		}
	}
</style>